module.exports = __webpack_public_path__ + "img/toup.9866a0b8.png";